import {
  CHAT_ALERT_CONTENT_CLASS_NAME,
  CHAT_DIALOG_HEADER_CLASS_NAME,
  CHAT_DIALOG_DESCRIPTION_CLASS_NAME,
  CHAT_DIALOG_FOOTER_CLASS_NAME,
} from "@/features/chat/chat-dialog-styles";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DownloadWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  fileName: string;
}

export const DownloadWarningDialog = ({
  open,
  onOpenChange,
  onConfirm,
  fileName,
}: DownloadWarningDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={CHAT_ALERT_CONTENT_CLASS_NAME}>
        <AlertDialogHeader className={CHAT_DIALOG_HEADER_CLASS_NAME}>
          <AlertDialogTitle>Download file?</AlertDialogTitle>
          <AlertDialogDescription
            className={CHAT_DIALOG_DESCRIPTION_CLASS_NAME}
          >
            You are about to download <strong>{fileName}</strong>. Be cautious
            with files from others and do not download files you were not
            expecting to receive.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className={CHAT_DIALOG_FOOTER_CLASS_NAME}>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Download</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
